"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.8614 16.2679-.8295-.8295a3.9815 3.9815 0 0 1-2.032.5539c-2.2091 0-4-1.7909-4-4 0-.7418.202-1.4365.5538-2.032L7.4102 8.8168c-.9654.7303-1.7915 1.5635-2.4132 2.2691a18.748 18.748 0 0 0-.7567.9149c.4214.5445 1.1436 1.4084 2.0731 2.2644C7.8884 15.7158 9.9 17.0008 12 17.0008c.979 0 1.9432-.2788 2.8615-.7329zm1.4779 1.4779 2.2479 2.2479 1.4142-1.4142L5.4297 4.0078 4.0155 5.422l1.9688 1.9688c-1.011.7937-1.8575 1.6574-2.4879 2.3729-.6233.7074-1.1763 1.4554-1.7005 2.2371.3449.545.7284 1.0657 1.1341 1.5668.4773.5895 1.1695 1.3776 2.0285 2.1688C6.641 17.2859 9.1295 19.0008 12 19.0008c1.5965 0 3.0694-.5312 4.3394-1.255zm-6.2716-6.2716 2.4503 2.4503c-1.4541.3889-2.8315-1.0251-2.4503-2.4503zm5.8949 1.0666c.3491-2.5455-1.9453-4.8631-4.5112-4.5112l4.5112 4.5112zm4.5412 1.6968a20.267 20.267 0 0 1-1.4017 1.4426l-1.4153-1.4153c.9217-.849 1.6508-1.7187 2.0728-2.2641-.4214-.5445-1.1436-1.4083-2.0732-2.2644-1.5749-1.4505-3.5864-2.7356-5.6865-2.7356-.4698 0-.9363.0642-1.396.1812L9.0206 5.5987c.924-.366 1.9247-.5979 2.9793-.5979 2.8705 0 5.359 1.715 7.0415 3.2644 1.194 1.0998 2.299 2.3566 3.1631 3.7356-.2386.3554-.4747.7116-.7328 1.0534a20.4696 20.4696 0 0 1-.9679 1.1834z"
  })];
};
exports.default = _default;